import { apiNeueDispatchAction } from 'src/utils/journeyApi';
import { useEditorContext } from 'src/store/editor';
import { useCurrentOrganization } from 'src/store/organization';
import { useEditorStore } from './editor-store';
import fastq from 'fastq';

const BACKOFF_TIMEOUT_MS = 4000;
const MIN_TIMEOUT_MS = 50;
const BACKOFF_ITERATION = Math.floor(Math.log2(BACKOFF_TIMEOUT_MS / MIN_TIMEOUT_MS));

function timeout(iteration: number): number {
  if (iteration <= BACKOFF_ITERATION) {
    return MIN_TIMEOUT_MS * Math.pow(2, iteration);
  } else {
    return BACKOFF_TIMEOUT_MS;
  }
}
async function sendWithRetries(f: Function) {
    for (let i = 0; ;i++) {
      try {
        const result = await f();
        useEditorStore.getState().setOnline();
        return result;
      } catch (err: any) {
        if (err.message === 'Network Error') {
          console.log(err);
          useEditorStore.getState().setOffline();
          await new Promise((r) => setTimeout(r, timeout(i)));
        } else {
          return Promise.reject(err);
        }
      }
    }
  }

const q = fastq.promise(async (actions: any[]) => {
    const result = await sendWithRetries(() => apiNeueDispatchAction(actions));
    return result;
  }, 1);

export async function enqueNeueDispatchActions(actions: any[]): Promise<any> {
  return await q.push(actions)
}

export async function sync(serverActions: any[]) {
  console.log('sendActionToServer', serverActions);
  const { journey } = useEditorContext.getState();
  const { currentOrganization } = useCurrentOrganization.getState();
  const context = { journey_uuid: journey.uuid, organization_id: currentOrganization.id };
  const preparedActions = serverActions.map((sa) => { return { action: sa, context: context } });
  try {
    return await enqueNeueDispatchActions(preparedActions);
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     lscache.set(`neue-journey-${journey.id}`, serverAction.payload.json);
    //     resolve({});
    //   }, 1000);
    // });
  } catch (e) {
    console.error('Error dispatching action to server', e);
    return Promise.reject(`Error dispatching action to server: ${e}`);
  }
}